// Vaste, taal-onafhankelijke anchor-slugs voor de FAQ-categorieën, in
// dezelfde volgorde als "faq.categories" in de i18n-bestanden. Gebruikt door
// zowel Navbar.js (dropdown-links) als FAQ.js (sectie-id's + scroll-to-hash),
// zodat een klik in de dropdown altijd naar de juiste sectie springt,
// ongeacht de actieve taal.
const FAQ_CATEGORY_SLUGS = [
  'algemeen',
  'toegangsbeheer',
  'schoonmaak',
  'automation',
  'samenwerken',
];

export default FAQ_CATEGORY_SLUGS;
